import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "phone-number-container bsp-page" }
const _hoisted_2 = {
  key: 0,
  class: "phone-number-loaded bsp-page__content"
}
const _hoisted_3 = {
  class: "bsp-section webhooks-section",
  "aria-labelledby": "webhooks-title"
}
const _hoisted_4 = { class: "bsp-section-heading bsp-section-heading--toolbar" }
const _hoisted_5 = { class: "bsp-section-heading__title-row" }
const _hoisted_6 = {
  key: 0,
  class: "bsp-webhook-list"
}
const _hoisted_7 = { class: "bsp-webhook-card__heading" }
const _hoisted_8 = { class: "bsp-webhook-card__identity" }
const _hoisted_9 = {
  class: "bsp-webhook-card__icon",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "bsp-webhook-card__actions" }
const _hoisted_11 = { class: "bsp-webhook-card__body" }
const _hoisted_12 = { class: "bsp-webhook-card__footer" }
const _hoisted_13 = { class: "bsp-webhook-card__toggle" }
const _hoisted_14 = { class: "bsp-webhook-card__health" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "bsp-section",
  "aria-labelledby": "testing-mode-title"
}
const _hoisted_18 = { class: "bsp-setting-row" }
const _hoisted_19 = {
  key: 1,
  class: "bsp-advanced-section"
}
const _hoisted_20 = { class: "bsp-advanced-section__content" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "bsp-danger-zone" }
const _hoisted_23 = { class: "bsp-danger-zone__actions" }
const _hoisted_24 = { class: "bsp-modal-form" }
const _hoisted_25 = { class: "resend-pin" }
const _hoisted_26 = { key: 0 }

import { useRouter, useRoute } from 'vue-router'
import AuthService from '../services/AuthService/AuthService'
import { onMounted, ref, computed, watch } from 'vue'
import SpinnerLoader from '../components/loaders/SpinnerLoader.vue'
import { User } from '../services/AuthService/types'
import { Establishment } from '../services/EstablishmentService/types'
import { PhoneNumber } from '../services/AccountService/types'
// import AccountService from '../services/AccountService/AccountService'
import { POSITION, useToast } from 'vue-toastification'
import EstablishmentService from '@/services/EstablishmentService/EstablishmentService'
import AccountService from '@/services/AccountService/AccountService'
import MetaService from '@/services/MetaService/MetaService'
import BspPageHeader from '@/components/BspPageHeader.vue'
import {
  AButton,
  AEmptyViewCard,
  AIcon,
  AInput,
  AModal,
  ASwitch,
  ATag
} from '@adereso-ai/vue-components'


export default /*@__PURE__*/_defineComponent({
  __name: 'PhoneNumberView',
  setup(__props) {


const router = useRouter()
const route = useRoute()
const toast = useToast()

const loading = ref(true)
const currentUser = ref<User | undefined>(undefined)
const currentEstablishment = ref<Establishment | undefined>(undefined)
// const establishmentName = ref('')
const phoneNumber = ref<PhoneNumber | undefined>(undefined)

const healthStatusResponse = ref<any>({})

const phoneBreadcrumbs = computed(() => [
  {
    title: 'WhatsApp Accounts',
    icon: 'tabler:brand-whatsapp',
    to: { name: 'whatsapp-business-accounts' }
  },
  {
    title: 'Account',
    to: {
      name: 'whatsapp-business-account',
      params: { wabaId: String(route.params.wabaId) }
    }
  },
  {
    title: phoneNumber.value?.verified_name || 'Phone number',
    disabled: true
  }
])

const isVerifyPhoneModalOpen = ref(false)
const pinCode = ref('')
const isVerifyButtonEnabled = computed(() => {
  return pinCode.value.trim().length > 0
})
const isResendPinDisabled = ref(true)
const resendPinTimer = ref(60)
let resendPinInterval: any = null

const isSuperUser = computed(() => {
  return currentUser.value?.roles.includes('superuser')
})

const webhooks = computed(() => Object.values(phoneNumber.value?.webhooks || {}))
const webhookCount = computed(() => webhooks.value.length)

function cleanPinCode (value: string) {
  return value.replace(/\D/g, '') // Solo números
}

watch(pinCode, (newValue: string) => {
  pinCode.value = cleanPinCode(newValue)
})

function openVerifyPhoneModal () {
  isVerifyPhoneModalOpen.value = true
  document.body.style.overflow = 'hidden' // Evitar scroll en el fondo
  startResendPinTimer()
  requestPin() // Solicitar PIN al abrir el modal
}

function closeVerifyPhoneModal () {
  isVerifyPhoneModalOpen.value = false
  document.body.style.overflow = 'auto' // Restaurar scroll
  resetVerifyPhoneModal()
}

function resetVerifyPhoneModal () {
  pinCode.value = ''
  isResendPinDisabled.value = true
  resendPinTimer.value = 60
  clearInterval(resendPinInterval)
}

async function verifyPhoneNumber () {
  if (phoneNumber.value) {
    loading.value = true
    const metaService = await MetaService.getInstance()
    try {
      await metaService.verifyAndRegisterPhone(phoneNumber.value.id, pinCode.value)
      toastSuccess('Phone number verified successfully')
      closeVerifyPhoneModal()
      await getPhoneHealthStatus()
    } catch (error) {
      toastError('Error verifying phone number: ' + error)
    }
    loading.value = false
  }
}

function startResendPinTimer () {
  isResendPinDisabled.value = true
  resendPinTimer.value = 60
  resendPinInterval = setInterval(() => {
    resendPinTimer.value--
    if (resendPinTimer.value <= 0) {
      isResendPinDisabled.value = false
      clearInterval(resendPinInterval)
    }
  }, 1000)
}

async function requestPin () {
  if (phoneNumber.value) {
    loading.value = true
    const metaService = await MetaService.getInstance()
    try {
      await metaService.requestPhonePin(phoneNumber.value.id)
      toastSuccess('PIN code requested successfully')
      startResendPinTimer()
    } catch (error) {
      toastError('Error requesting PIN code: ' + error)
    }
    loading.value = false
  }
}

async function resendPin () {
  await requestPin()
}

function goBack () {
  router.back()
}

function goToMessageTemplates () {
  router.push({ name: 'message-templates', params: { phoneNumberId: phoneNumber.value?.id, wabaId: phoneNumber.value?.waba_id } })
}

function goToBusinessProfile () {
  router.push({ name: 'business-profile', params: { phoneNumberId: phoneNumber.value?.id, wabaId: phoneNumber.value?.waba_id } })
}

async function savePhoneNumber () {
  loading.value = true
  if (phoneNumber.value) {
    const accountService = await AccountService.getInstance()
    try {
      await accountService.updatePhoneNumber(phoneNumber.value)
      toastSuccess('Phone updated')
    } catch (error) {
      toastError('Error updating account: ' + error)
    }
  }
  loading.value = false
}

async function getPhoneHealthStatus () {
  loading.value = true
  if (phoneNumber.value) {
    const metaService = await MetaService.getInstance()
    try {
      const response = await metaService.getPhoneHealthStatus(phoneNumber.value)
      healthStatusResponse.value = response
      toastSuccess('Phone health status: ' + JSON.stringify(response))
    } catch (error) {
      toastError('Error getting phone health status: ' + error)
    }
  }
  loading.value = false
}

function deleteWebhook (webhookId: string) {
  if (phoneNumber.value) {
    delete phoneNumber.value.webhooks[webhookId]
  }
}

function addWebhook () {
  if (phoneNumber.value) {
    // generate random webhook id
    const webhookId = Math.random().toString(36).substring(7)
    const webhook = {
      id: webhookId,
      url: '',
      enabled: false
    }
    phoneNumber.value.webhooks[webhook.id] = webhook
  }
}

async function deletePhoneNumber () {
  loading.value = true
  const accountService = await AccountService.getInstance()
  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string
  try {
    await accountService.deletePhoneNumber(wabaId, phoneNumberId)
    toastSuccess('Phone number deleted')
    goBack()
  } catch (error) {
    toastError('Error deleting phone number')
  }
  loading.value = false
}

async function getEstablishment () {
  const establishmentService = await EstablishmentService.getInstance()
  try {
    const establishment = await establishmentService.getCurrentEstablishment()
    currentEstablishment.value = establishment
  } catch (error) {
    // do nothing
  }
}

async function getCurrentUser () {
  const authService = await AuthService.getInstance()
  currentUser.value = authService.currentUser.value
  if (authService.currentUser.value == null) {
    router.push({ name: 'login', query: route.query })
  }
}

async function getphoneNumber (wabaId: string, phoneNumberId: string) {
  try {
    const accountService = await AccountService.getInstance()
    phoneNumber.value = await accountService.getphoneNumber(wabaId, phoneNumberId)
  } catch {
    toastError('Error getting phone number')
  }
}

onMounted(async () => {
  await router.isReady()

  await getCurrentUser()

  await getEstablishment()

  const phoneNumberId = route.params.phoneNumberId as string
  const wabaId = route.params.wabaId as string

  if (phoneNumberId && wabaId) {
    await getphoneNumber(wabaId, phoneNumberId)
  } else {
    router.push({ name: 'home' })
  }

  loading.value = false
})

function toastError (errorMessage: string) {
  try {
    toast.error(String(errorMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}

function toastSuccess (successMessage: string) {
  try {
    toast.success(String(successMessage), {
      position: POSITION.BOTTOM_LEFT
    })
  } catch (error) {
    console.log('error on toast:', error)
  }
}

console.log(toastSuccess)


return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!loading.value && phoneNumber.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(BspPageHeader, {
            breadcrumbs: phoneBreadcrumbs.value,
            title: phoneNumber.value.verified_name,
            description: phoneNumber.value.display_phone_number,
            eyebrow: "WhatsApp phone number",
            icon: "tabler:phone",
            status: phoneNumber.value.testing_mode ? 'Test mode' : 'Active',
            "status-color": phoneNumber.value.testing_mode ? 'warning' : 'success'
          }, {
            actions: _withCtx(() => [
              _createVNode(_unref(AButton), {
                variant: "outlined",
                "prepend-icon": "tabler:message",
                onClick: goToMessageTemplates
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Templates ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(AButton), {
                variant: "outlined",
                "prepend-icon": "tabler:building-store",
                onClick: goToBusinessProfile
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode(" Business profile ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(AButton), {
                color: "blue",
                "prepend-icon": "tabler:device-floppy",
                onClick: savePhoneNumber
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createTextVNode(" Save changes ", -1)
                ]))]),
                _: 1
              })
            ]),
            meta: _withCtx(() => [
              _createVNode(_unref(ATag), {
                text: `ID ${phoneNumber.value.id}`,
                color: "info",
                type: "secondary"
              }, null, 8, ["text"])
            ]),
            _: 1
          }, 8, ["breadcrumbs", "title", "description", "status", "status-color"]),
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[6] || (_cache[6] = _createElementVNode("h2", { id: "webhooks-title" }, "Webhooks", -1)),
                  _createVNode(_unref(ATag), {
                    text: `${webhookCount.value}`,
                    color: "primary",
                    type: "secondary"
                  }, null, 8, ["text"])
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("p", null, "Define the destinations that will receive events associated with this phone number.", -1))
              ]),
              _createVNode(_unref(AButton), {
                variant: "outlined",
                color: "blue",
                "prepend-icon": "tabler:plus",
                onClick: addWebhook
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode(" Add webhook ", -1)
                ]))]),
                _: 1
              })
            ]),
            (webhookCount.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(webhooks.value, (webhook, webhookIndex) => {
                    return (_openBlock(), _createBlock(_component_v_card, {
                      class: "bsp-webhook-card",
                      variant: "flat",
                      key: webhook.id
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, [
                              _createVNode(_unref(AIcon), {
                                icon: "tabler:webhook",
                                color: "primary",
                                size: "20"
                              })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("h3", null, "Destination " + _toDisplayString(webhookIndex + 1), 1),
                              _cache[9] || (_cache[9] = _createElementVNode("p", null, "Configure where events from this phone number will be received.", -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_unref(ATag), {
                              text: webhook.enabled ? 'Enabled' : 'Disabled',
                              color: webhook.enabled ? 'success' : 'info',
                              type: "secondary",
                              pill: ""
                            }, null, 8, ["text", "color"]),
                            _createVNode(_unref(AButton), {
                              icon: "tabler:trash",
                              color: "red",
                              variant: "text",
                              size: "small",
                              "help-text": "Delete webhook",
                              "aria-label": "Delete webhook",
                              onClick: ($event: any) => (deleteWebhook(webhook.id))
                            }, null, 8, ["onClick"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(_unref(AInput), {
                            modelValue: webhook.url,
                            "onUpdate:modelValue": ($event: any) => ((webhook.url) = $event),
                            label: "Webhook URL",
                            placeholder: "https://example.com/webhook",
                            "prepend-inner-icon": "tabler:webhook"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("h4", null, "Event reception", -1)),
                                _createElementVNode("p", null, _toDisplayString(webhook.enabled ? 'This destination is receiving events.' : 'Enable it to start receiving events.'), 1)
                              ]),
                              _createVNode(_unref(ASwitch), {
                                modelValue: webhook.enabled,
                                "onUpdate:modelValue": ($event: any) => ((webhook.enabled) = $event),
                                label: "Enable"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_unref(AIcon), {
                                icon: webhook.error_count ? 'tabler:alert-triangle' : 'tabler:circle-check',
                                color: webhook.error_count ? 'warning' : 'success',
                                size: "19"
                              }, null, 8, ["icon", "color"]),
                              _createElementVNode("div", null, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", null, "Delivery status", -1)),
                                (webhook.disabled_at)
                                  ? (_openBlock(), _createElementBlock("strong", _hoisted_15, "Disabled: " + _toDisplayString(webhook.disabled_at), 1))
                                  : (_openBlock(), _createElementBlock("strong", _hoisted_16, "No blocks recorded"))
                              ]),
                              _createVNode(_unref(ATag), {
                                text: `${webhook.error_count || 0} of ${webhook.error_limit || 100} errors`,
                                color: webhook.error_count ? 'warning' : 'success',
                                type: "secondary",
                                pill: ""
                              }, null, 8, ["text", "color"])
                            ])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock(_unref(AEmptyViewCard), {
                  key: 1,
                  icon: "tabler:webhook-off",
                  title: "No webhooks configured",
                  description: "Add a URL to start receiving events.",
                  "action-button-label": "Add webhook",
                  onAction: addWebhook
                }))
          ]),
          (isSuperUser.value)
            ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _cache[12] || (_cache[12] = _createElementVNode("div", null, [
                    _createElementVNode("h2", { id: "testing-mode-title" }, "Test mode"),
                    _createElementVNode("p", null, "Simulate outgoing templates without sending real messages and generate a random WAMID.")
                  ], -1)),
                  _createVNode(_unref(ASwitch), {
                    modelValue: phoneNumber.value.testing_mode,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phoneNumber.value.testing_mode) = $event)),
                    label: "Enable test mode"
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (isSuperUser.value)
            ? (_openBlock(), _createElementBlock("details", _hoisted_19, [
                _createElementVNode("summary", null, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", null, [
                    _createElementVNode("strong", null, "Phone number diagnostics"),
                    _createElementVNode("small", null, "Check the health status reported by Meta.")
                  ], -1)),
                  _createVNode(_unref(AIcon), {
                    icon: "tabler:chevron-down",
                    size: "18"
                  })
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_unref(AButton), {
                    variant: "outlined",
                    "prepend-icon": "tabler:activity-heartbeat",
                    onClick: getPhoneHealthStatus
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode(" Check status ", -1)
                    ]))]),
                    _: 1
                  }),
                  (healthStatusResponse.value)
                    ? (_openBlock(), _createElementBlock("pre", _hoisted_21, _toDisplayString(healthStatusResponse.value), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_22, [
            _cache[17] || (_cache[17] = _createElementVNode("div", null, [
              _createElementVNode("h2", null, "Phone number actions"),
              _createElementVNode("p", null, "Request a PIN to verify the phone number or remove it from the account.")
            ], -1)),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_unref(AButton), {
                variant: "outlined",
                "prepend-icon": "tabler:shield-check",
                onClick: openVerifyPhoneModal
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode(" Request PIN and verify ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(AButton), {
                color: "red",
                variant: "outlined",
                "prepend-icon": "tabler:trash",
                onClick: deletePhoneNumber
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode(" Delete phone number ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ]))
      : (_openBlock(), _createBlock(SpinnerLoader, { key: 1 })),
    _createVNode(_unref(AModal), {
      modelValue: isVerifyPhoneModalOpen.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isVerifyPhoneModalOpen).value = $event)),
      title: "Verify phone number",
      "prepend-title-icon": "tabler:shield-check",
      width: "520px",
      "close-disabled": loading.value,
      onOnClose: closeVerifyPhoneModal
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _cache[19] || (_cache[19] = _createElementVNode("p", null, "Enter the PIN sent by Meta to complete verification.", -1)),
          _createVNode(_unref(AInput), {
            modelValue: pinCode.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pinCode).value = $event)),
            label: "PIN code",
            placeholder: "000000",
            required: ""
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_unref(AButton), {
              variant: "text",
              size: "small",
              disabled: isResendPinDisabled.value,
              onClick: resendPin
            }, {
              default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                _createTextVNode(" Resend PIN ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            (isResendPinDisabled.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, "Available in " + _toDisplayString(resendPinTimer.value) + " seconds.", 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createVNode(_unref(AButton), {
          variant: "text",
          disabled: loading.value,
          onClick: closeVerifyPhoneModal
        }, {
          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_unref(AButton), {
          color: "blue",
          loading: loading.value,
          disabled: !isVerifyButtonEnabled.value,
          onClick: verifyPhoneNumber
        }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
            _createTextVNode(" Verify phone number ", -1)
          ]))]),
          _: 1
        }, 8, ["loading", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue", "close-disabled"])
  ]))
}
}

})